import { useEffect, useState } from 'react';
import axios from './axiosInstances/axiosInstance';

export type UseFetchReporterId  = {
  loading: boolean;
  reporterId: string | null;
};


export const useFetchJiraId = (jiraMailId: string): UseFetchReporterId => {
  const [reporterId, setReporterId] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const proxyCredentialData = async () => {
      try {
        const response: UseFetchReporterId = await axios.get('/qs/qatab/getJiraAccountId', {
          params: {
            jiraMailId: jiraMailId,
          },
        });

        setReporterId(response);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    proxyCredentialData();
  }, [jiraMailId]);

  return { loading, reporterId };
};